/** Lead id for file viewers. Architects / unlinked projects fall back to the timber project id. */
export function resolveFileViewerLeadId(
  leadId: string | undefined,
  dealLeadId: string | undefined,
  projectId: string,
): string {
  return (leadId || dealLeadId || projectId).trim();
}
